<div class="forgot-password-container">
  <div class="forgot-password-card">
    <div class="forgot-password-header">
      <h1 class="forgot-password-logo">leah</h1>
      <p class="forgot-password-subtitle">Passwort zurücksetzen</p>
    </div>

    @if (isSubmitted()) {
    <div class="success-message">
      <p>Falls ein Konto mit dieser E-Mail-Adresse existiert, haben wir Ihnen eine Anleitung zum Zurücksetzen Ihres
        Passworts gesendet.</p>
      <p>Bitte überprüfen Sie Ihre E-Mails und folgen Sie dem Link, um ein neues Passwort festzulegen.</p>
    </div>

    <div class="form-links">
      <a routerLink="/auth/login">Zurück zur Anmeldung</a>
    </div>
    } @else {
    <p class="forgot-password-description">
      Geben Sie Ihre E-Mail-Adresse ein und wir senden Ihnen einen Link zum Zurücksetzen Ihres Passworts.
    </p>

    <form [formGroup]="form" (ngSubmit)="onSubmit()">
      <div class="form-field">
        <label for="email">E-Mail</label>
        <input id="email" type="email" pInputText formControlName="email" placeholder="E-Mail-Adresse eingeben" />
      </div>

      <div class="form-actions">
        <p-button type="submit" label="Link senden" [disabled]="form.invalid" [loading]="isLoading()"
          styleClass="w-full" />
      </div>

      <div class="form-links">
        <a routerLink="/auth/login">Zurück zur Anmeldung</a>
      </div>
    </form>
    }
  </div>
</div>